import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-lcl-footer',
  template: `
    <footer [ngClass]="{ 'is-fixed': isFixed, 'is-fixed-to-left-bottom': isFromAuth }">
      <div class="lcl-footer-content">
        <ng-content select="[footer]"></ng-content>
      </div>
    </footer>
  `,
  styleUrls: ['./lcl-footer.component.scss'],
})
export class LclFooterComponent {
  @Input() public isFixed: boolean;
  @Input() public isFromAuth: boolean;
}
